import ChatButton from '../components/ChatButton';
import Icon from '../components/Icon';
import LeadForm from '../components/LeadForm';
import PageHero from '../components/PageHero';
import { site } from '../config';

export default function Contact() {
  return (
    <>
      <PageHero title="Contact">Chat, call, or send a request — whichever is easiest for you.</PageHero>

      <section className="section">
        <div className="wrap contact-grid">
          <div className="contact-list">
            <div className="contact-item">
              <span className="card-icon">
                <Icon name="chat" />
              </span>
              <div>
                <h2>Live chat</h2>
                <p>The fastest way to reach us. Usually answered within two minutes.</p>
                <ChatButton size="sm" />
              </div>
            </div>
            <div className="contact-item">
              <span className="card-icon">
                <Icon name="phone" />
              </span>
              <div>
                <h2>Phone</h2>
                <p>
                  <a href={site.phoneHref}>{site.phone}</a>
                </p>
              </div>
            </div>
            <div className="contact-item">
              <span className="card-icon">
                <Icon name="mail" />
              </span>
              <div>
                <h2>Email</h2>
                <p>
                  <a href={`mailto:${site.email}`}>{site.email}</a>
                </p>
              </div>
            </div>
            <div className="contact-item">
              <span className="card-icon">
                <Icon name="clock" />
              </span>
              <div>
                <h2>Hours</h2>
                <p>{site.hours}</p>
              </div>
            </div>
          </div>
          <LeadForm source="contact-page" title="Send us a message" />
        </div>
      </section>
    </>
  );
}
